import { render, staticRenderFns } from "./PayrollReportBuilder.vue?vue&type=template&id=38a44602&"
import script from "./PayrollReportBuilder.vue?vue&type=script&lang=ts&"
export * from "./PayrollReportBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./PayrollReportBuilder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports